import { Button, Modal, TextInput } from "flowbite-react";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Loader from "../Common/Loader";
import { CategoryCustom } from "../../Models/CategoryCustom";
import CommonApi from "../../Api/CommonApi";

export default function EditCategoryModal({
  show,
  setShow,
  category,
  onRefresh,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  category: CategoryCustom | null;
  onRefresh: () => Promise<void> | undefined;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const initialFormState: CategoryCustom = {
    number: 0,
    name: "",
    subCategories: [],
    count: 0,
  };

  const [formData, setFormData] = useState<CategoryCustom>(initialFormState);

  useEffect(() => {
    if (category) {
      setFormData({
        number: category.number,
        name: category.name || "",
        subCategories: category.subCategories ?? [],
        count: category.count || 0,
      });
    } else {
      setFormData(initialFormState);
    }
  }, [category]);

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    setButtonDisabled(true);
    e.preventDefault();
    try {
      setIsLoading(true);
      const payload: CategoryCustom = {
        ...formData,
        subCategories: formData.subCategories ?? [],
      };
      return CommonApi.addUpdateCategory(payload)
        .then((res) => {
          if (res.data.success) {
            toast.success("Category updated successfully");
            setIsLoading(false);
            setButtonDisabled(false);
            onRefresh();
            setShow(false);
          } else {
            toast.error(res.data.message);
            setIsLoading(false);
            setButtonDisabled(false);
          }
        })
        .catch((err) => {
          toast.error("Error: " + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  function onCloseModal() {
    setShow(false);
  }

  return (
    <Modal show={show} size="md" onClose={onCloseModal} popup>
      <Modal.Header>{category ? "Edit Category" : "Add Category"}</Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <form onSubmit={onSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Category Number (Read Only)
                </label>
                <div className="px-3 py-2 bg-gray-100 border border-gray-300 rounded-md text-gray-700">
                  {category?.number || "N/A"}
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Category Name
                </label>
                <TextInput
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Enter category name..."
                  onChange={handleChangeInput}
                  value={formData.name ?? ""}
                  sizing="md"
                  required
                />
              </div>
            </div>
            <div className="flex justify-end pt-4 space-x-2">
              <Button
                disabled={buttonDisabled}
                type="submit"
                className="buttonMain"
              >
                {isLoading ? <Loader /> : "Save"}
              </Button>
              <Button
                color="gray"
                onClick={onCloseModal}
                disabled={buttonDisabled}
              >
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}
